import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored user on mount
    const storedUser = localStorage.getItem('thirugoo_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const sendOTP = async (phone) => {
    try {
      const response = await axios.post(`${API}/auth/send-otp`, { phone });
      return response.data;
    } catch (error) {
      throw error.response?.data || { detail: 'Failed to send OTP' };
    }
  };

  const verifyOTP = async (phone, otp) => {
    try {
      const response = await axios.post(`${API}/auth/verify-otp`, { phone, otp });
      if (!response.data.is_new_user && response.data.user) {
        setUser(response.data.user);
        localStorage.setItem('thirugoo_user', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      throw error.response?.data || { detail: 'Invalid OTP' };
    }
  };

  const register = async (phone, name, role) => {
    try {
      const response = await axios.post(`${API}/auth/register`, { phone, name, role });
      setUser(response.data);
      localStorage.setItem('thirugoo_user', JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      throw error.response?.data || { detail: 'Registration failed' };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('thirugoo_user');
  };

  const updateUser = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('thirugoo_user', JSON.stringify(updatedUser));
  };

  return (
    <AuthContext.Provider value={{ user, loading, sendOTP, verifyOTP, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
